// Function to update cart count in real time
function updateCartCount(forceCount) {
  const apply = (count) => {
    const cartCountElements = document.querySelectorAll('.header-cart-count, .data-cart-count');
    cartCountElements.forEach(element => {
      if (count > 0) {
        element.setAttribute('data-visible', 'true');
        element.textContent = count > 99 ? '99+' : count;
      } else {
        element.setAttribute('data-visible', 'false');
      }
    });
  };

  if (typeof forceCount === 'number') {
    apply(forceCount);
    return;
  }

  fetch('/cart.json?t=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
    .then(response => response.json())
    .then(cart => apply(cart.item_count))
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Hook fetch and XHR to detect cart updates globally
(function() {
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
      const res = await originalFetch(input, init);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/(\/cart\/(add|change|update|clear)\.js|\/cart\.json|\/cart)/.test(url) && res && res.ok) {
          let applied = false;
          try {
            const ct = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
            if (ct.indexOf('application/json') > -1) {
              const data = await res.clone().json();
              if (data && typeof data.item_count === 'number') {
                updateCartCount(data.item_count);
                applied = true;
              }
            }
          } catch (e) {}
          if (!applied) {
            setTimeout(function(){ updateCartCount(); }, 150);
            setTimeout(function(){ updateCartCount(); }, 600);
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      } catch (e) {}
      return res;
    };
  }

  if (window.XMLHttpRequest) {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__cart_url__ = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function() {
      this.addEventListener('load', function() {
        try {
          const url = this.__cart_url__ || '';
          if (/(\/cart\/(add|change|update|clear)\.js|\/cart\.json|\/cart)/.test(url) && this.status >= 200 && this.status < 300) {
            let applied = false;
            try {
              const ct = this.getResponseHeader && this.getResponseHeader('Content-Type') || '';
              if (ct.indexOf('application/json') > -1) {
                const data = JSON.parse(this.responseText || 'null');
                if (data && typeof data.item_count === 'number') {
                  updateCartCount(data.item_count);
                  applied = true;
                }
              }
            } catch (e) {}
            if (!applied) {
              setTimeout(function(){ updateCartCount(); }, 150);
              setTimeout(function(){ updateCartCount(); }, 600);
            }
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        } catch (e) {}
      });
      return origSend.apply(this, arguments);
    };
  }
})();

// Convert normal product form submissions to AJAX and update cart count
function ajaxifyProductForms() {
  var forms = document.querySelectorAll('form[action*="/cart/add"]:not([data-ajaxified])');
  forms.forEach(function(form) {
    form.setAttribute('data-ajaxified', 'true');
    form.addEventListener('submit', function(e) {
      if (e.defaultPrevented || form.hasAttribute('data-skip-ajax')) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
      .then(function(r){ if(!r.ok) throw new Error('Add to cart failed'); return r.json(); })
      .then(function(){
        updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:added'));
      })
      .catch(function(err){
        console.error(err);
        form.submit();
      });
    }, { passive: false });
  });
}

document.addEventListener('DOMContentLoaded', ajaxifyProductForms);
document.addEventListener('shopify:section:load', ajaxifyProductForms);